// AbsentDetails.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
  navigate,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AbsentDetails = () => {
  const [absentEmployees, setAbsentEmployees] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token") || "YOUR_FALLBACK_TOKEN";
    const config = { headers: { Authorization: `Bearer ${token}` } };

    // Fetch all employees using the /employee/list endpoint.
    axios
      .get("https://attendanceapi.gensparc.com/employee/list", config)
      .then((empResponse) => {
        const allEmployees = empResponse.data; // Assuming it returns an array
        console.log("All Employees:", allEmployees);

        // Fetch today's punch records from the /punch/list endpoint.
        axios
          .get("https://attendanceapi.gensparc.com/punch/list", config)
          .then((attResponse) => {
            let records = attResponse.data;
            // If the API wraps the data in another property, adjust accordingly.
            if (!Array.isArray(records) && records.data) {
              records = records.data;
            }
            console.log("Attendance Records:", records);

            // Get today's date in YYYY-MM-DD format.
            const today = new Date().toISOString().split("T")[0];

            // Extract checked-in usernames for records where checkIn is today.
            const checkedInUsernames = records
              .filter(
                (record) => record.checkIn && record.checkIn.startsWith(today)
              )
              .map((record) => record.username.trim().toLowerCase());
            console.log("Checked-In Usernames:", checkedInUsernames);

            // Filter employees: those whose employee_name is not in the checkedInUsernames list.
            const absent = allEmployees.filter((employee) => {
              // Normalize the name from employee list. Adjust field name if necessary.
              const empName = employee.employee_name
                ? employee.employee_name.trim().toLowerCase()
                : "";
              return !checkedInUsernames.includes(empName);
            });
            console.log("Absent Employees:", absent);

            setAbsentEmployees(absent);
          })
          .catch((error) =>
            console.error("Error fetching attendance records:", error)
          );
      })
      .catch((error) => console.error("Error fetching employee list:", error));
  }, []);
  const handleBackClick = () => {
    navigate("/dashboard");
  };

  return (
    <Box sx={{ padding: 0, backgroundColor: "#fafafa", minHeight: "100vh" }}>
      <Box display="flex" alignItems="center" marginBottom={3}>
        <IconButton onClick={handleBackClick} aria-label="back" sx={{marginTop:10}}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ flexGrow: 1, textAlign: "center", marginTop:10 }}
        >
          Absent Employees Details
        </Typography>
      </Box>
      {absentEmployees.length > 0 ? (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "auto", margin: "auto" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Employee Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Department</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Role</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {absentEmployees.map((employee) => (
                <TableRow key={employee.id}>
                  <TableCell>{employee.employee_name}</TableCell>
                  <TableCell>{employee.department || "N/A"}</TableCell>
                  <TableCell>{employee.role || "N/A"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" align="center">
          No absent employees for today.
        </Typography>
      )}
    </Box>
  );
};

export default AbsentDetails;
